
module.exports = function init_swiper() {

  var swiper_implant_projection = new Swiper ('.swiper-sientra-implants-projection', {
    direction: 'horizontal',
    loop: true,
    effect: 'fade',
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      dynamicBullets: false,
    },
    autoplay: {
      delay: 1500,
    },  
  });

};